export default "__VITE_ASSET__DlfzP64X__"